module.exports = __webpack_public_path__ + "img/pantanal.a04b375d.png";